<div arcSharedUserActive class="layout-wrapper" (click)="onLayoutClick()">
  <aur-loading-spinner
    class="spinner"
    *ngIf="showBlockUILoading"
  ></aur-loading-spinner>
  <div
    #layoutContainer
    class="layout-container menu-layout-static menu-layout-horizontal"
  >
    <app-payment-header
      *ngIf="showPaymentHeader$ | async"
      [logoImageUrl]="headerLogoUrl"
    ></app-payment-header>
    <!--
      BTPAY-7200: the ARC theme reserves a 64px band at the bottom of
      `.layout-main` below 839.99px (aureus `_index.scss` ->
      `.layout-main:not(.no-padding)`), meant for the mobile bottom bar that
      other ARC apps render. This checkout shell has no bottom bar, so those
      64px are dead space under the payment footer. `no-padding` is the theme's
      own opt-out; it appears in no other rule, and the base `.layout-main`
      padding is already 0, so this changes nothing above 839.99px.
    -->
    <div class="no-padding" [ngClass]="{ 'layout-main': isloggedin$ | async }">
      <div class="layout-content" *ngIf="!loading">
        <router-outlet id="arcMainContent"></router-outlet>
      </div>
    </div>
  </div>
  <app-sessiontimeout *ngIf="showSessionTimeOut$ | async"></app-sessiontimeout>
</div>
